/** @jsxImportSource @emotion/react */
import UI from "@mile-meeting/mile-ui";
import { Container, ImageContainer, WorkspaceCreateContainer } from "./index.styles";
import { css } from "@emotion/react";
import { useRef, useState } from "react";
import { createWorkspace } from "apis/workspace";
import { uploadImageToS3 } from "apis/uploadImage";
import { TUser } from "apis/user/index";
import { accessWorkspace } from "apis/auth/member";
import { encrypt } from "utils/crypto";
import { logout } from "apis/auth/logout";
import { useRecoilValue } from "recoil";
import { user } from "recoil/recoilState";

const WorkspaceCreate = () => {
  const userInfo = useRecoilValue(user);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [image, setImage] = useState<string>();
  const [name, setName] = useState<string>();

  const onHandleLogout = async () => {
    const res = await logout();
    if (res.success) {
      localStorage.clear();
      window.location.href = "/login";
    }
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    //Input태그에서 이미지를 선택했을 경우, 작동하는 로직입니다.
    const files = e.target.files;
    if (files && files.length > 0) {
      const file = files[0];
      const previewUrl = URL.createObjectURL(file);
      setImage(previewUrl);
    }
  };

  const uploadImage = async (image?: string) => {
    if (!image) {
      return null;
    }

    // blob URL을 fetch하여 Blob 파일로 변환
    if (typeof image === "string" && image.startsWith("blob:")) {
      const response = await fetch(image);
      const blob = await response.blob();
      const formData = new FormData();
      formData.append("file", blob);
      const imageUrl = await uploadImageToS3(formData);
      return imageUrl;
    }

    // image가 string일 경우 그대로 반환 (이미 업로드된 URL일 가능성)
    if (typeof image === "string") return image;
  };

  const onHandleCreate = async () => {
    //워크스페이스 생성을 클릭했을 때 동작하는 로직입니다.
    if (enableBtn() && name) {
      let imageUrl = (await uploadImage(image)) ?? "";
      const { success, message, member } = await createWorkspace(name, imageUrl);
      if (success) {
        onHandleAccessWorkspace(member);
      } else alert(message);
    }
  };

  const onHandleAccessWorkspace = async (member: TUser) => {
    //워크스페이스를 접속할 때 실행되는 로직입니다.
    const res = await accessWorkspace(member);
    if (res.success && res.accessToken) {
      if (res.user?.autoLogin) localStorage.setItem("access-token", encrypt(res.accessToken));
      else if (!res.user?.autoLogin) sessionStorage.setItem("access-token", encrypt(res.accessToken));

      window.location.href = "/setting/워크스페이스 관리";
    } else {
      alert(res.message);
    }
  };

  const enableBtn = () => {
    //워크스페이스 생성 버튼이 활성화 될 수 있는 조건입니다.
    if (name && name?.length > 0 && name?.length < 51) {
      return true;
    } else return false;
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
      <UI.Navigation.TopNav
        isShowProfile
        isShowLogout
        profileName={userInfo?.name ?? "-"}
        onHandleLogout={onHandleLogout}
      />
      <Container>
        <WorkspaceCreateContainer>
          <UI.Typography type="title01" fontStyle="bold">
            워크스페이스 생성
          </UI.Typography>
          <UI.Typography
            type="label01"
            fontStyle="bold"
            color="var(--alias-color-label-alternative)"
            style={{ marginTop: "40px", marginBottom: "20px", textAlign: "start" }}
          >
            워크스페이스 아이콘
          </UI.Typography>
          <ImageContainer
            src={image ?? "https://mile-storage.s3.ap-northeast-2.amazonaws.com/web/workspace-upload-image-icon.png"}
            onClick={() => fileInputRef.current?.click()}
          />
          <input type="file" ref={fileInputRef} style={{ display: "none" }} onChange={handleFileChange} />
          <UI.Typography
            style={{ margin: "16px auto 40px auto" }}
            type="label02"
            fontStyle="regular"
            color="var(--alias-color-label-alternative)"
          >
            워크스페이스를 대표하는 이미지를 업로드해주세요.
            <br />
            (1:1 비율, 권장 규격: 240px* 240px)
          </UI.Typography>
          <div
            css={css`
              display: flex;
              flex-direction: column;
              gap: 4px;
              text-align: start;
              margin-bottom: 40px;
            `}
          >
            <UI.Typography type="label01" fontStyle="bold" color="var(--alias-color-label-alternative)">
              워크스페이스 이름
              <span
                css={css`
                  color: var(--alias-color-primary-normal);
                `}
              >
                *
              </span>
            </UI.Typography>
            <UI.Input
              maxLength={50}
              showMaxLength
              value={name}
              onChange={setName}
              showHelpText
              placeholder="워크스페이스 이름"
              helpText="회사나 조직의 이름을 작성해 주세요."
            ></UI.Input>
          </div>
          <UI.Button size="large" title="워크스페이스 생성" disabled={!enableBtn()} onClick={onHandleCreate} />
        </WorkspaceCreateContainer>
      </Container>
    </div>
  );
};

export default WorkspaceCreate;
